import { ref } from 'vue';
const isShareModalOpen = ref(false);
export const useShareRecommendation = () => {
    const openShareModal = () => {
        isShareModalOpen.value = true;
    };
    const closeShareModal = () => {
        isShareModalOpen.value = false;
    };
    return {
        isShareModalOpen,
        openShareModal,
        closeShareModal
    };
};
